import * as types from '../../actions/types'
import socket from '../../helpers/socket'


const initialState = {
  seen: [],
  chats: [],
  unreadCount: []
}

export function messageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.MESSAGES_REQUEST:
      return state;
    case types.MESSAGES_ON_RECEIVE:
      //console.log(action.payload)

      let chat = state.chats.filter(el => el.contactId === action.payload.contactId);
      let messages = chat.length === 0 ? [] : chat[0].messages;
      let ownerMessages = action.payload.messages
        .filter(el => el.to === action.payload.contactId).reverse()
      let seen = ownerMessages.length > 0 ? ownerMessages[0].seen : false

      let o = Object.assign({}, state,
        {
          seen: seen ?
            [
              ...state.seen.filter(el => el !== action.payload.contactId),
              action.payload.contactId
            ] : state.seen,
          chats: state.chats
            .filter(el => el.contactId !== action.payload.contactId)
            .concat({
              contactId: action.payload.contactId,
              messages: [
                ...messages,
                ...action.payload.messages
              ]
            })
        })
      //console.log(o);
      return o;
    case types.MESSAGES_RECEIVED_UNREAD_COUNT:
      return Object.assign({}, state, {
        unreadCount: action.payload.map(el => {
          return { contactId: el._id.owner, count: el.count }
        }
        )
      })
    case types.MESSAGE_ON_RECEIVE_NEW:
      //modal is opened and visible
      console.log('MESS', action.payload.contactModalsHidden.includes(action.payload.message.owner))
      console.log('MESS', action.payload.contactModalsHidden, action.payload.message.owner)
      // show new message:
      if (action.payload.contactModals.includes(action.payload.message.owner) &&
        !action.payload.contactModalsHidden.includes(action.payload.message.owner)
      ) {
        // mark message read:
        socket.emit('messagesMarkRead', {
          owner: action.payload.message.owner
        })

        let chat = state.chats.filter(el => el.contactId === action.payload.message.owner);
        let messages = chat.length === 0 ? [] : chat[0].messages;
        state = Object.assign({}, state,
          {
            chats: state.chats
              .filter(el => el.contactId !== action.payload.message.owner)
              .concat({
                contactId: action.payload.message.owner,
                messages: [
                  ...messages,
                  action.payload.message
                ]
              })
          })
        let unreadCount = state.unreadCount.filter(el => el.contactId === action.payload.message.owner)
        if (unreadCount.length === 0)
          return Object.assign({}, state, {
            unreadCount: [
              ...state.unreadCount.filter(el => el.contactId !== action.payload.message.owner),
              { contactId: action.payload.message.owner, count: 1 }
            ]
          })
        else
          return Object.assign({}, state, {
            unreadCount: [
              ...state.unreadCount.filter(el => el.contactId !== action.payload.message.owner),
              { contactId: action.payload.message.owner, count: unreadCount[0].count + 1 }
            ]
          })
      } else { //modal is closed increase unreadCount
        let unreadCount = state.unreadCount.filter(el => el.contactId === action.payload.message.owner)
        if (unreadCount.length === 0)
          return Object.assign({}, state, {
            unreadCount: [
              ...state.unreadCount.filter(el => el.contactId !== action.payload.message.owner),
              { contactId: action.payload.message.owner, count: 1 }
            ]
          })
        else
          return Object.assign({}, state, {
            unreadCount: [
              ...state.unreadCount.filter(el => el.contactId !== action.payload.message.owner),
              { contactId: action.payload.message.owner, count: unreadCount[0].count + 1 }
            ]
          })
      }
    case types.MESSAGES_ON_MARK_READ:
      return Object.assign({}, state, {
        unreadCount: [
          ...state.unreadCount.filter(el => el.contactId !== action.payload.owner)
        ]
      });

    case types.MESSAGES_ON_SEND:
      return Object.assign({}, state, {
        seen: [
          ...state.seen.filter(el => el !== action.payload.to)
        ]
      });

    case types.MESSAGES_ON_SEEN:
      return Object.assign({}, state, {
        seen: [
          ...state.seen.filter(el => el !== action.payload.to),
          action.payload.to
        ]
      });

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/chat/messageReducer.js